import React from 'react';
import Menu from '../Components/Menu';

function Vietnam() {
  return (
    <div>
      <div>
        {/* Navbar & Hero Start */}
        <div className="container-fluid position-relative p-0">
          <div className="container-fluid bg-primary py-5 mb-5 hero-header">
            <div className="container py-5">
              <div className="row justify-content-center py-5">
                <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
                  <h1 className="display-3 text-white animated slideInDown">
                    Vietnam
                  </h1>
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb justify-content-center">
                      <li className="breadcrumb-item">
                        <a href="#">Home</a>
                      </li>
                      <li className="breadcrumb-item">
                        <a href="#">Destination</a>
                      </li>
                      <li
                        className="breadcrumb-item text-white active"
                        aria-current="page"
                      >
                        Vietnam
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Navbar & Hero End */}

        <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
          <h6 className="section-title bg-white text-center text-primary px-3">
            Destination
          </h6>
          <h1 className="mb-5">5 famous tourist destinations in Vietnam</h1>
        </div>
      </div>

      <div className="container">
        <div className="content">
          <p>
            Vietnam offers a myriad of fascinating tourist destinations. Whether
            you travel to the northern, central, or southern regions, you will
            have the opportunity to witness majestic mountains, stunning
            beaches, bustling cities, as well as serene and poetic riverine
            landscapes. So let's embark on a journey from the north to the south
            and explore all the must-visit tourist spots that Vietnam has to
            offer!
          </p>
          <h3 className="text">1. Ha Long Bay</h3>
          <p>
            When it comes to the most famous tourist destinations in Vietnam,
            the first one to mention is undoubtedly Hạ Long Bay, located in
            Quảng Ninh province. As one of the Seven Natural Wonders of the
            World, Hạ Long Bay is renowned not only for its stunning and
            majestic beauty but also as a colossal geological museum, preserving
            significant traces of time.
          </p>
          <p>
            Visiting Ha Long Bay, tourists will have the opportunity to explore
            unique caves and beautiful islands such as Dragon Eye Island, Ngoc
            Vung Island, and Frog Island. Moreover, this place is also a
            culinary paradise with a variety of delicious specialties like squid
            sausage, dried seahorse, and grilled oysters. If you are a fan of
            resort-style travel, Hạ Long Bay is indeed the perfect destination
            for you.
          </p>
          <center>
            <img
              src="img/vietnam1.jpg"
              alt=""
              style={{ width: 900, height: 505 }}
            />
          </center>{' '}
          <br />
          <br />
          <h3 className="text">2. Ho Chi Minh Cty</h3>
          <p>
            Ho Chi Minh City, also known as Saigon, is recognized as one of the
            two largest economic and financial centers in Vietnam. It stands out
            for its dynamic, modern, and bustling atmosphere, making it a
            must-visit destination. When you visit Ho Chi Minh City, you will
            have the opportunity to admire its vibrant streets, filled with
            numerous prominent attractions such as Nguyen Hue Walking Street,
            Nhà Rồng Wharf, and Independence Palace
          </p>
          <p>
            Aside from its famous tourist attractions, the unique cuisine of
            Saigon is also a major draw for visitors. From humble street food
            such as broken rice (cơm tấm), snails (ốc), and banh mi (Vietnamese
            sandwich) to upscale and luxurious restaurants, Saigon offers a wide
            range of culinary experiences that will delight your taste buds.
            Whether you indulge in seafood hotpot or savor exquisite dishes at
            high-end establishments, you are sure to have an exceptional
            gastronomic adventure in Saigon.
          </p>
          <center>
            <img
              src="img/vietnam2.jpg"
              alt=""
              style={{ width: 900, height: 505 }}
            />
          </center>{' '}
          <br />
          <br />
          <h3 className="text">3. Hue</h3>
          <p>
            Huế is a Vietnamese tourist destination that exudes an ancient and
            dreamlike beauty, as well as a rich and longstanding cultural and
            historical significance. When visiting Huế, travelers can feel a
            sense of tranquility through its poetic landscapes and experience
            the warm hospitality of the local people. The city's serene ambiance
            and the genuine kindness of its residents contribute to creating a
            peaceful and welcoming atmosphere for visitors.
          </p>
          <p>
            A distinctive highlight of Huế is its ancient beauty, showcased
            through architectural wonders such as the Huế Imperial City (Đại Nội
            Huế), Thiên Mụ Pagoda, Ngọ Môn Gate, Thái Hòa Palace, and Tràng Tiền
            Bridge. When visiting Huế, don't forget to take a boat ride along
            the Perfume River (sông Hương) to enjoy a cup of tea, listen to
            traditional music, and indulge in the exquisite cuisine that
            includes both royal and local dishes unique to Huế.
          </p>
          <center>
            <img
              src="img/vietnam3.jpg"
              alt=""
              style={{ width: 900, height: 505 }}
            />
          </center>{' '}
          <br />
          <br />
          <h3 className="text">4. Phong Nha-Ke Bang National Park</h3>
          <p>
            Phong Nha-Ke Bang National Park has long been a renowned landmark in
            Vietnam, admired for its unparalleled natural beauty and grandeur.
            Located in Quang Binh province, it is a harmonious combination of
            mountains and rivers, creating a picturesque and poetic landscape
            that is both majestic and romantic.
          </p>
          <p>
            When you visit Phong Nha-Ke Bang npNational Park, you will feel like
            you have entered a pristine and mysterious world with over 300 caves
            of various sizes. Moreover, it is an ideal destination for those who
            love exploration, thanks to its underground river system and ancient
            limestone mountains that have existed for millions of years. Phong
            Nha-Ke Bang has been recognized by UNESCO as a World Natural
            Heritage site and has become a famous tourist attraction, attracting
            numerous visitors from both within and outside the country.
          </p>
          <center>
            <img
              src="img/vietnam4.jpg"
              alt=""
              style={{ width: 900, height: 505 }}
            />
          </center>{' '}
          <br />
          <br />
          <h3 className="text">5. Hoi An</h3>
          <p>
            Hoi An is perhaps a well-known tourist destination in Vietnam, both
            for domestic and international travelers. It impresses visitors with
            its ancient and romantic beauty. Situated peacefully along the Hoai
            River, the scenery in Hoi An is as picturesque as a poetic painting,
            adorned with vibrant and colorful lanterns.
          </p>
          <center>
            <img
              src="img/vietnam5.jpg"
              alt=""
              style={{ width: 900, height: 505 }}
            />
          </center>{' '}
          <br />
          <br />
          <p>
            When visiting Hoi An, tourists will have the opportunity to admire
            unique architectural heritage that has existed for hundreds of
            years, as well as enjoy various attractive attractions such as Cu
            Lao Cham, Cua Dai Beach, and Tra Que Vegetable Village. The local
            cuisine is also a highlight that delights many visitors, with
            delicious dishes such as Cao Lau, Hoanh Thanh, and Mi Quang.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Vietnam;
